module.exports = __webpack_public_path__ + "img/door.516f3b87.svg";